

































































import Component from "vue-class-component";
import {Mixins, Prop, ProvideReactive} from "vue-property-decorator";
import { Tag } from '@/types/models';
import { default as mixins } from '../mixins/user';
import VueButton from '@/components/forms/button.vue';
import VueTagsInline from '@/components/forms/tags-inline.vue';
import VueMarkdown from '@/components/forms/markdown.vue';
import VueText from '@/components/forms/text.vue';
import VueSelect from '@/components/forms/select.vue';
import VueError from '@/components/forms/error.vue';
import { mapMutations, mapState } from 'vuex';
import VueFormGroup from "@/components/forms/form-group.vue";
import store from '@/store';
import { GuideMixin } from "@/components/mixins/guide";

@Component({
  mixins: [ mixins ],
  store,
  components: {
    'vue-form-group': VueFormGroup,
    'vue-text': VueText,
    'vue-select': VueSelect,
    'vue-markdown': VueMarkdown,
    'vue-button': VueButton,
    'vue-tags-inline': VueTagsInline,
    'vue-error': VueError
  },
  computed: {
    ...mapState('guides', ['guide'])
  },
  methods: {
    ...mapMutations('guides', ['TOGGLE_TAG'])
  },
  inject: []
})
export default class VueForm extends Mixins(GuideMixin) {
  public errors = {};
  private isProcessing = false;

  @Prop({default: () => []})
  @ProvideReactive('popularTags')
  readonly popularTags!: Tag[];

  cancel() {
    store.commit('guides/EDIT');
  }

  save() {
    this.isProcessing = true;

    return store.dispatch('guides/save')
      .then(response => {
        this.$emit('save');

        if (response.status === 201) {
          window.location.href = response.data.url;
        }
      })
      .catch(err => {
        if (err.response?.status !== 422) {
          return;
        }

        this.errors = err.response?.data.errors;
      })
      .finally(() => this.isProcessing = false);
  }
}
